import { PaymentOptionDto } from "@api-types/payment-options/PaymentOptionDto";
import {
	UserTypes,
	getAgencyKey,
	getApplicationHeaders,
	httpClient,
} from "@utils";

class PaymentOptionsApiService {
	get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}${getAgencyKey()}/payment-options`;
	}

	getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders(UserTypes.PRIMARY, false);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	async getFooterMethods(): Promise<PaymentOptionDto[]> {
		return await httpClient.get(
			`${this.baseUrl}/footer-methods`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	async getPaymentOptions(): Promise<PaymentOptionDto[]> {
		return await httpClient.get(
			`${this.baseUrl}`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}
}

const paymentOptionsApiService = new PaymentOptionsApiService();

export { paymentOptionsApiService };
